export const SUBJECT_UPDATE_LIST = 'SUBJECT_UPDATE_LIST'
export const SUBJECT_UPDATE_LIST_METHOD = 'SUBJECT_UPDATE_LIST_METHOD'
export const SUBJECT_UPDATE_FORM = 'SUBJECT_UPDATE_FORM'
export const SUBJECT_UPDATE_ERROR = 'SUBJECT_UPDATE_ERROR'
export const SUBJECT_UPDATE_FORM_FIELD = 'SUBJECT_UPDATE_FORM_FIELD'
export const SUBJECT_UPDATE_PREVIEW = 'SUBJECT_UPDATE_PREVIEW'

export const updateSubjectsList = (curriculumId, { data, count }) => ({
  type: SUBJECT_UPDATE_LIST,
  payload: { curriculumId, data, count }
})
export const updateSubjectsListMethod = (curriculumId, method, data) => ({
  type: SUBJECT_UPDATE_LIST_METHOD,
  payload: { curriculumId, method, data }
})
export const updateSubjectForm = (data) => ({
  type: SUBJECT_UPDATE_FORM,
  payload: data
})
export const updateSubjectError = (data) => ({
  type: SUBJECT_UPDATE_ERROR,
  payload: data
})
export const updateSubjectFormField = (field, value) => ({
  type: SUBJECT_UPDATE_FORM_FIELD,
  payload: { field, value }
})

export const updateSubjectPreview = (preview = null) => ({
  type: SUBJECT_UPDATE_PREVIEW,
  payload: preview
})